import styled from 'styled-components';

export const BoardContainer = styled.div`
    width: 100%;
    padding: 20px;
    background-color: #FFFFFF;
`;

export const BoardHeader = styled.div`
    display: grid;
    grid-template-columns: 120px repeat(5, 1fr);
    gap: 0;
    margin-bottom: 0;
`;

export const MachineSelector = styled.div`
    padding: 12px 16px;
    background-color: transparent;
    border: none;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #303030;
    display: flex;
    align-items: center;
`;

export const WeekdaysHeader = styled.div`
    display: contents;
`;

export const DayColumn = styled.div`
    padding: 12px 16px;
    background-color: #F5F5F5;
    border: 1px solid #E0E0E0;
    border-right: none;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #303030;
    text-align: center;

    &:last-child {
        border-right: 1px solid #E0E0E0;
    }
`;

export const BoardGrid = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MachineRow = styled.div`
    display: grid;
    grid-template-columns: 120px repeat(5, 1fr);
    gap: 0;
    border-bottom: none;
`;

export const MachineCell = styled.div`
    padding: 16px;
    background-color: #F5F5F5;
    border: 1px solid #E0E0E0;
    border-top: none;
    border-right: none;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #303030;
    display: flex;
    align-items: center;
`;

export const DayCell = styled.div`
    padding: 8px;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-top: none;
    border-right: none;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    &:last-child {
        border-right: 1px solid #E0E0E0;
    }
`;

export const OPCard = styled.div`
    padding: 6px 10px;
    background-color: #E8F5FA;
    border: 1px solid #0090D3;
    border-radius: 4px;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #0090D3;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #D0ECF7;
        transform: translateY(-1px);
    }
`;
